
































import { Component, Vue } from "vue-property-decorator";
import { Senior } from "@/api/models/Senior";
import senioren from "@/api/content/senioren/senioren.json";

@Component
export default class HistorySenioren extends Vue {
    /**
     * Get the list of senioren.
     */
    get senioren(): Array<Senior> {
        return senioren;
    }

    /**
     * Get the color of the entry in the timeline.
     *  even is primary
     *  uneven is secondary
     * @param index
     */
    getTimelineColor(index: number): string {
        return index % 2 === 0 ? "primary" : "secondary";
    }
}
